<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">添加買入交易</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <businessadd @submit="pageback"></businessadd>
  </div>
</template>

<script>
import  businessadd from "@/components/BuyBusinessAdd.vue";
export default {
  components: {
    businessadd
  },
  data () {
    return {
    };
  },
  methods: {
    pageback () {
      this.$router.go(-1);
    },
  }
};
</script>
<style scoped>
	
		
			
</style>
